import { useState } from "react";
import { motion } from "framer-motion";
import { HelpCircle, Check, X, ArrowRight } from "lucide-react";
import { useLang } from "../../context/LanguageContext";

export const CheckpointBlock = ({ block, onDone }) => {
  const { t } = useLang();
  const [picked, setPicked] = useState(null);

  const isCorrect = picked === block.correct_index;

  return (
    <motion.div initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} className="card-dark p-7 sm:p-10" data-testid="learn-block-checkpoint">
      <span className="badge-lime inline-flex items-center gap-2"><HelpCircle className="w-3.5 h-3.5" /> {t("learn.checkpoint")}</span>
      <h2 className="font-heading font-black text-xl sm:text-2xl text-[#0B1B3A] mt-5 leading-snug" data-testid="learn-checkpoint-question">{block.question}</h2>
      <div className="grid grid-cols-1 gap-3 mt-7">
        {block.options.map((opt, i) => {
          const state = picked === null ? "idle" : i === block.correct_index ? "right" : i === picked ? "wrong" : "dim";
          const cls = {
            idle: "",
            right: "!border-[#1D4ED8] !border-b-[#0F2B7A] !bg-[#EEF4FF] text-[#0B1B3A]",
            wrong: "!border-[#FCA5A5] !border-b-[#F87171] !bg-[#FEF2F2] text-[#B91C1C]",
            dim: "!text-[#94A3B8] opacity-70",
          }[state];
          return (
            <button
              key={i}
              data-testid={`learn-checkpoint-option-${i}`}
              disabled={picked !== null}
              onClick={() => setPicked(i)}
              className={`quiz-option flex items-center gap-3 ${cls}`}
            >
              {state === "right" && <Check className="w-4 h-4 shrink-0" />}
              {state === "wrong" && <X className="w-4 h-4 shrink-0" />}
              {opt}
            </button>
          );
        })}
      </div>
      {picked !== null && (
        <div className="mt-7 rounded-[20px] bg-[#F8FAFC] border border-[#E2E8F0] p-5" data-testid="learn-checkpoint-feedback">
          <p className="text-sm font-bold text-[#0B1B3A]">{isCorrect ? t("learn.correct") : t("learn.notQuite")}</p>
          {block.explanation && <p className="text-sm text-[#475569] mt-2">{block.explanation}</p>}
        </div>
      )}
      {picked !== null && (
        <button data-testid="learn-checkpoint-continue" onClick={() => onDone(picked)} className="btn-blue mt-7">
          {t("learn.continue")} <ArrowRight className="w-4 h-4" />
        </button>
      )}
    </motion.div>
  );
};

export default CheckpointBlock;
